export default __webpack_public_path__ + "static/media/frontdesk-room-view.8c61b03a.jpg";